<template>
  <!-- 订单列表 -->
  <div id="userOrder" v-loading.fullscreen.lock="fullscreenLoading">
    <Dialog ref="dialog" :config="config" />

    <div class="tabsContainer">
      <el-tabs v-model="form.status" @tab-click="handleClick" ref="tabs">
        <!-- 所有订单 -->
        <el-tab-pane name="all">
          <template #label>
            <div>
              {{ $fanyi('全部') }}
            </div>
            <div class="num_box">
              {{ `(${allTabText})` }}
            </div>
          </template>
        </el-tab-pane>
        <!-- 临时保存 -->
        <el-tab-pane name="temporary">
          <template #label>
            <div>
              {{ $fanyi('临时保存订单') }}
            </div>
            <div class="num_box">
              {{ `(${temporaryTabText})` }}
            </div>
          </template>
        </el-tab-pane>
        <!-- 等待报价 报价中 -->
        <el-tab-pane name="offer">
          <template #label>
            <div>
              {{ $fanyi('等待报价') }}
            </div>
            <div class="num_box">
              {{ `(${awaitQuoteTabText})` }}
            </div>
          </template>
        </el-tab-pane>

        <!-- 待付款 -->
        <el-tab-pane name="obligation">
          <template #label>
            <div>
              {{ $fanyi('等待支付') }}
            </div>
            <div class="num_box">
              {{ `(${obligationTabText})` }}
            </div>
          </template>
        </el-tab-pane>
        <!-- 等待财务确认 == 支付中 -->
        <el-tab-pane name="Pending financial confirmation">
          <template #label>
            <div>
              {{ $fanyi('支付中') }}
            </div>
            <div class="num_box">
              {{ `(${WaitforfinancialconfirmationText})` }}
            </div>
          </template>
        </el-tab-pane>

        <!-- 处理中 -->
        <el-tab-pane name="shelves">
          <template #label>
            <div>
              {{ $fanyi('处理中') }}
            </div>
            <div class="num_box">
              {{ `(${ProcessingText})` }}
            </div>
          </template>
        </el-tab-pane>
        <!-- 上架完了 -->
        <el-tab-pane name="warehouse">
          <template #label>
            <div>
              {{ $fanyi('上架完了') }}
            </div>
            <div class="num_box">
              {{ `(${InstockText})` }}
            </div>
          </template>
        </el-tab-pane>
        <!-- 国际运输中 -->
        <el-tab-pane name="In transit">
          <template #label>
            <div>
              {{ $fanyi('国际运输中') }}
            </div>
            <div class="num_box">
              {{ `(${IntransitText})` }}
            </div>
          </template>
        </el-tab-pane>

        <!-- 已签收 -->
        <el-tab-pane name="Delivered">
          <template #label>
            <div>
              {{ $fanyi('已签收') }}
            </div>
            <div class="num_box">
              {{ `(${DeliveredText})` }}
            </div>
          </template>
        </el-tab-pane>

        <el-tab-pane name="delete">
          <template #label>
            <div>
              {{ $fanyi('取消的订单') }}
            </div>
            <div class="num_box">
              {{ `(${CancelText})` }}
            </div>
          </template>
        </el-tab-pane>

      </el-tabs>

    </div>
    <!-- 列表区域 -->
    <div class="list" v-loading="loanding">
      <div class="searchBox">
        <div class="myInput">
          <i class="el-icon-search"></i>
          <input type="text" v-model="form.searchText" @keydown.enter="getData(form)"
            :placeholder="$fanyi('请输入订单号/配送单号/商品ID搜索')" />
        </div>
        <el-date-picker v-model="time" type="datetimerange" :start-placeholder="$fanyi('开始日期')"
          :range-separator="$fanyi('')" :end-placeholder="$fanyi('结束日期')" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']" @change="setFromDate">
        </el-date-picker>

        <button class="searchBtn" @click="
          form.page = 1
        getData(form)
          ">
          {{ $fanyi('搜索') }}
        </button>
        <!-- 清除 -->
        <div class="reset" @click="resetOrder">
          {{ $fanyi('清除') }}
        </div>

        <!-- <div class="cancelledBtn" @click="showCancelledOrder" >
          {{ showDeleteShow === false ? $fanyi('已取消订单') : $fanyi('返回') }}
        </div> -->
      </div>
      <div class="dataBody">
        <ul class="ohead">
          <!-- No -->
          <li class="oNO" :style="(form.status == 'obligation' ? 'flex:0.15' : '',
            form.status == 'delete' ? 'flex:0.15' : '')
            ">
            <span class="tableHeadCon">NO</span>
          </li>
          <li class="orderNumber">
            <span class="tableHeadCon" :title="$fanyi('订单号')">{{
              $fanyi('订单号')
            }}</span>
          </li>
          <li class="datePresentation"
            v-if="form.status != 'temporary' && form.status != 'In transit' && form.status != 'Delivered'" :style="form.status == 'delete'
              ? 'flex:0 0 170px'
              : form.status == 'offer'
                ? 'flex:0 0 400px'
                : ''
              ">
            <span class="tableHeadCon" :title="$fanyi('提出日期')">{{
              $fanyi('提出日期')
            }}</span>
          </li>
          <!-- 付款日期，取消日期公用 -->
          <li class="datePresentation"
            v-if="form.status != 'temporary' && form.status != 'offer' && form.status != 'all'"
            :style="form.status == 'delete' ? 'flex:0.7' : ''">
            <span class="tableHeadCon" :title="$fanyi('付款日期')">{{
              form.status == 'delete'
                ? $fanyi('订单取消日期')
                : $fanyi('付款日期')
            }}</span>
          </li>
          <li class="datePresentation" v-if="
            form.status != 'temporary' &&
            form.status != 'obligation' &&
            form.status != 'delete' &&
            form.status != 'offer'
          ">
            <span class="tableHeadCon" :title="$fanyi('购买完成日期')">
              {{ $fanyi('购买完成日期') }}</span>
          </li>
          <li class="upLoad" v-if="['purchase', 'purchased'].indexOf(form.status) != -1">
            <span class="tableHeadCon" :title="$fanyi('导出excel')">{{
              $fanyi('导出excel')
            }}</span>
          </li>
          <li :style="form.status == 'obligation' || form.status == 'obligation'
            ? 'flex: 0 0 170px'
            : form.status == 'temporary'
              ? 'flex: 0 0 512px'
              : ''
            ">
            <span class="tableHeadCon" :title="$fanyi('订单状态')">{{
              $fanyi('订单状态')
            }}</span>
          </li>
          <li v-if="['temporary', 'obligation'].indexOf(form.status) != -1">
            <span class="tableHeadCon" :title="$fanyi('操作')">{{
              $fanyi('操作')
            }}</span>
          </li>
          <!-- 装箱单 -->
          <li :style="{ flex: '0 0 300px' }" v-if="['all', 'In transit', 'Delivered'].indexOf(form.status) != -1">
            <span class="tableHeadCon" :title="$fanyi('装箱单')">{{
              $fanyi('装箱单')
            }}</span>
          </li>
        </ul>
        <!-- 表格区域 -->
        <ul class="obody" v-for="(item, index) in tableData.data" :key="$fanyi('表格') + index">
          <li class="oNO" :style="(form.status == 'obligation' ? 'flex:0.15' : '',
            form.status == 'delete' ? 'flex:0.15' : '')
            ">
            {{ index + 1 }}
          </li>
          <!-- 订单号 -->
          <li class="orderNumber">
            <button @click="toDetailPage(item)">
              {{ item.order_sn }}
            </button>
          </li>
          <!-- 提出日期 -->
          <li class="datePresentation"
            v-if="form.status != 'temporary' && form.status != 'In transit' && form.status != 'Delivered'" :style="form.status == 'delete'
              ? 'flex:0 0 170px'
              : form.status == 'offer'
                ? 'flex:0 0 400px'
                : ''
              ">
            {{ item.created_at }}
          </li>
          <!-- 付款日期 -->
          <li class="datePresentation" v-if="
            form.status != 'temporary' &&
            form.status != 'delete' &&
            form.status != 'offer' && form.status != 'all'
          ">
            {{
              item.order_time_node
                ? item.order_time_node.datetime_pay_submit
                  ? item.order_time_node.datetime_pay_submit
                  : '- -'
                : '- -'
            }}
          </li>
          <!-- 订单取消日期 -->
          <li class="datePresentation" v-if="
            form.status != 'temporary' &&
            form.status != 'obligation' &&
            form.status != 'offer'
          " :style="form.status == 'delete' ? 'flex:0.7' : ''">
            {{
              item.delete_time
                ? item.delete_time
                : item.order_time_node
                  ? item.order_time_node.datetime_purchase_complete
                    ? item.order_time_node.datetime_purchase_complete
                    : '- -'
                  : '- -'
            }}
          </li>

          <li :style="form.status == 'obligation'
            ? 'flex: 0 0 170px'
            : form.status == 'temporary'
              ? 'flex: 0 0 512px'
              : ''
            ">
            {{ textConversion(item.statusName) }}
          </li>
          <li v-if="['temporary', 'obligation'].indexOf(form.status) != -1">
            <span v-if="
              item.statusName == 'obligation' ||
              item.statusName == 'temporary'
            " style="cursor: pointer" @click="delOrder(item.order_sn)" class="quxiao">{{ $fanyi('取消') }}</span>

            <button v-if="
              form.status === 'obligation' && item.statusName == 'obligation'
            " class="searchBtn" style="margin-left: 16px" @click="
              $fun.toPage(
                '/orderDetails?type=' +
                item.statusName +
                '&order_sn=' +
                item.order_sn
              )
              ">
              {{ $fanyi('前往付款') }}
            </button>
          </li>
          <!-- 装箱单 -->
          <li class="Packingbox" :style="{ flex: '0 0 300px' }"
            v-if="['all', 'In transit', 'Delivered'].indexOf(form.status) != -1">
            <div class="Packinglist" v-if="item.porder_sn">
              <div class="Dispatchnumber">
                <p @click="$fun.toPage('/deliveryDetails?order_sn=' + ite.porder_sn + '&status=' + ite.status, true)"
                  v-for="(ite, index) in item.porder_sn" :key="index"><span>{{ ite.porder_sn }}</span> <span
                    class="Orderstatus"> {{ $fanyi(ite.statusName) }}</span></p>
              </div>

            </div>
          </li>

        </ul>
        <div class="NoDaTa" v-if="tableData.data ? tableData.data.length == 0 : false">
          {{ $fanyi('暂无数据') }}
        </div>
      </div>

      <div class="allpag">
        <span></span>
        <el-pagination @current-change="handleCurrentChange" :current-page="form.currentPage" :page-size="10"
          :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from '../../../../components/public/Dialog'
import axios from 'axios'
import Europess from '../../../../api/wangZhi'
import { Loading } from 'element-ui'
let Europe = Europess + '/client/'
export default {
  name: 'order',
  data() {
    return {
      time: null,
      form: {
        status: 'all',
        page: 1,
        pageSize: 10,
        searchText: '',
        startTime: '',
        endTime: '',
      },
      loanding: false,

      fullscreenLoading: false,
      tableData: [],
      total: 0,
      tableOption: [], //表格显示哪些选项
      config: {
        top: '20vh',
        width: '500px',
        title: this.$fanyi('提示'),
        btnTxt: [this.$fanyi('确认'), this.$fanyi('取消')],
      },
      allTabText: 0,
      temporaryTabText: 0,
      awaitQuoteTabText: 0,
      obligationTabText: 0,
      WaitforfinancialconfirmationText: 0,
      ProcessingText: 0,
      InstockText: 0,
      IntransitText: 0,
      DeliveredText: 0,
      CancelText: 0,


      ordersSumList: {
        temporary: 0,
        delete: 0,
        purchased: 0,
        purchase: 0,
        obligation: 0,
        offer: 0,
        all: 0,
      }, //商品列表各种类商品数据
    }
  },
  components: { Dialog },
  computed: {},

  created() {
    this.form.page = 1
    this.form.pageSize = 10

    if (this.$route.query.status) {
      this.form.status = this.$route.query.status
      this.getData(this.form)
    } else {
      this.getData(this.form, true)
    }

    this.ordersSum()
  },
  methods: {
    //点击订单号跳转到详情
    toDetailPage(item) {
      let baseUrl = window.location.origin
      window.open(baseUrl + `/orderDetails?type=${item.statusName}&order_sn=${item.order_sn}`, '_blank')
    },
    // 清除事件
    resetOrder() {
      this.form = {
        status: 'all',
        page: 1,
        pageSize: 10,
        searchText: '',
        startTime: '',
        endTime: '',
      }
      this.$forceUpdate()
      this.getData(this.form, true)
    },
    textConversion(value) {
      // 把接口返回的状态名转换成西班牙语;
      let list = [
        {
          key: 'temporary',
          value: this.$fanyi('预购订单'),
        },
        {
          key: 'offer',
          value: this.$fanyi('等待报价'),
        },
        {
          key: 'obligation',
          value: this.$fanyi('等待支付'),
        },
        {
          key: 'purchase',
          value: this.$fanyi('正在购买'),
        },
        {
          key: 'purchased',
          value: this.$fanyi('购买完成'),
        },
        {
          key: 'Pending financial confirmation',
          value: this.$fanyi('支付中'),
        },
        {
          key: 'cancel',
          value: this.$fanyi('已取消(订单状态)'),
        },
        {
          key: 'delete',
          value: this.$fanyi('已删除'),
        },
        {
          key: 'shelves',
          value: this.$fanyi('上架中'),
        },
        {
          key: 'warehouse',
          value: this.$fanyi('上架完了'),
        },
        {
          key: 'shipping',
          value: this.$fanyi('出货完成'),
        }, {
          key: 'In transit',
          value: this.$fanyi('国际运输中'),
        },
        {
          key: 'Delivered',
          value: this.$fanyi('已签收'),
        },
      ]
      for (let i in list) {
        if (list[i].key == value) {
          return list[i].value
        }
      }

      return value
    },
    handleClick(tab) {
      this.form.page = 1
      this.getData(this.form)
    },
    gettabsoffset(tab) {
      this.$nextTick(() => {
        const currentEL = this.$refs.tabs.$el.querySelector(
          '.el-tabs__item.is-active'
        ) // 拿到当前高亮的
        console.log(currentEL);

        const barEl = this.$refs.tabs.$el.querySelector('.el-tabs__active-bar')
        barEl.style.transform = `translateX(${currentEL.offsetLeft + 20}px)`
      })
    },
    setFromDate() {
      if (this.time) {
        this.form.startTime = this.time[0]
        this.form.endTime = this.time[1]
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },


    // 获取每个状态的订单数量
    ordersSum() {
      this.$api
        .ordersSumV2()
        .then((res) => {
          if (res.data.length == 0) {
            this.ordersSumList.all = 0
            return
          }
          this.allTabText = res.data.all || 0
          this.temporaryTabText = res.data.temporarily_saved || 0
          this.awaitQuoteTabText = res.data.awaiting_quote || 0
          this.obligationTabText = res.data.awaiting_payment || 0
          this.WaitforfinancialconfirmationText = res.data.pending || 0

          this.ProcessingText = res.data.processing || 0

          this.InstockText = res.data.in_stock || 0

          this.IntransitText = res.data.in_transit || 0

          this.DeliveredText = res.data.delivered || 0
          this.CancelText = res.data.closed || 0



          this.ordersSumList = res.data
          if (this.form.status != 'all') {
            this.gettabsoffset()
          }
        })

    },
    // 获取数据，传fir代表页面打开时请求数据的场合
    getData(datas, fir) {
      this.tableData = []
      this.loanding = true
      this.$api
        .orderList(datas)
        .then((res) => {
          //预购订单有数据的时候默认展示预购订单，否则展示全部订单
          if (fir == true && res.data.data.length == 0) {
            this.form.status = 'all'
            this.getData(this.form)
          }
          this.loanding = false
          this.tableData = res.data
          this.total = res.data.total
          this.form.currentPage = res.data.currentPage
          this.$forceUpdate()
        })
        .catch((err) => { })
    },
    // 删除订单,根据订单状态分为硬删和软删
    delOrder(order_sn) {
      this.$refs.dialog.open(
        this.$fanyi('是否取消当前订单?'),
        (cancel) => {
          let datas = {
            order_sn: order_sn,
            deleteReason: this.$fanyi('删除'),
          }
          if (this.form.status == 'temporary') {
            this.$api.orderTampDelete(datas).then((res) => {
              cancel()
              if (res.code != 0) return

              this.getData(this.form)
              this.ordersSum()
            })
          } else {
            this.$api.orderRecycling(datas).then((res) => {
              if (res.code != 0) return
              this.getData(this.form)
              this.ordersSum()
            })
          }
        },
        () => { }
      )
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getData(this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.NoDaTa {
  font-size: 14px;
  color: #909399;
  text-align: center;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 80px;
}

#userOrder {
  @import '../../../../css/mixin';
  width: 1060px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;


  button {
    cursor: pointer;
  }

  /deep/.el-range-separator {
    width: 3px;
    height: 20px;
    // background-color: pink;
    background: url('../../../../assets/date.png') no-repeat center;
  }

  /deep/ .el-date-editor {
    position: relative;

    .el-input__icon {
      display: none;
    }
  }

  .tabsContainer {
    border-radius: 0;
    border-bottom: 1px solid #dfdfdf;
    min-height: 58px;
    max-height: 98px;
    padding-top: 10px;

    /deep/ .el-tabs {
      max-width: 1020px;
    }

    /deep/ .el-tabs__active-bar {
      background-color: #d12a1d;
      display: none;
    }

    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }

    /deep/ .el-icon-arrow-left {
      font-size: 14px;
    }

    /deep/.el-tabs__nav {

      flex-wrap: wrap;
      display: flex;
    }

    /deep/ .el-icon-arrow-right {
      font-size: 14px;
    }

    /deep/ .el-tabs__item {
      min-width: 80px;
      height: 40px;
      display: inline-block;
      font-size: 14px;


      margin-bottom: 5px;
      color: #121212;

      &:hover {
        color: #d12a1d;
      }

      &:nth-child(2) {
        padding-left: 20px;
      }
    }

    div {
      display: inline-block;
    }

    /deep/ .is-active {
      color: #d12a1d;

      &::after {
        content: '';
        position: absolute;
        width: 85%;
        left: 50%;
        transform: translateX(-50%);
        transition: all 0.3s ease-in-out;
        height: 2px;
        background-color: #d12a1d;
        bottom: -2px;
      }
    }
  }


  .list {

    padding: 0 20px;
    padding-top: 20px;
    min-height: 300px;

    .searchBox {
      display: flex;
      margin-bottom: 20px;

      .myInput {
        width: 360px;
        height: 40px;
        border-radius: 12px;
        position: relative;
        display: flex;
        align-items: center;
        // overflow: hidden;
        margin-right: 20px;

        >i {
          width: 20px;
          height: 24px;
          margin: 9px 11px 9px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #a2a2a2;
          position: absolute;
        }

        >input {
          border: 1px solid #e2e2e2;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          font-size: 14px;
          padding-left: 40px;
          padding-right: 10px;
          transition: 0.3s;

          &:focus {
            border-color: #ff730b;
          }

          &::placeholder {
            color: #9a9a9a;
          }
        }
      }

      /deep/.el-date-editor {
        border-radius: 12px;
        width: 296px;
        height: 40px;
        margin-right: 20px;
        line-height: 32px !important;

        .el-input__inner {
          padding: 0px !important;
          border-radius: 12px;
        }

        .el-range-input {
          font-size: 14px;
          border-radius: 12px;
        }

        .el-range-separator {
          width: 50px;
          line-height: 23px;
        }

        .el-range__icon {
          line-height: 25px;
        }
      }

      .searchBtn {
        width: 80px;
        height: 40px;
        background: #d12a1d;
        border-radius: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
      }

      .cancelledBtn {
        width: 130px;
        height: 40px;
        margin-left: 15px;
        border-radius: 12px;
        border: 1px solid #d12a1d;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;

        font-weight: 400;
        font-size: 16px;
        color: #d12a1d;

      }

      .reset {
        min-width: 82px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid #d12a1d;

        text-align: center;
        cursor: pointer;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 15px;
        font-weight: 400;
        font-size: 16px;
        color: #d12a1d;

      }
    }

    .dataBody {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #dfdfdf;

      >ul {
        display: flex;

        >li {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          // line-height: 56px;
          font-size: 14px;
          padding: 0 10px;
          text-align: center;
          color: #000000;
        }
      }

      ul.ohead {
        height: 50px;

        background: #f5f5f5;
        box-shadow: 0px 1px 0px 0px #dfdfdf;

        li {
          overflow: hidden;

          font-weight: 500;
          font-size: 14px;
          color: #121212;
          padding: 0 15px;
          line-height: 20px; // 设置一列

          &.oNO {
            flex: 0 0 70px;
          }

          &.orderNumber {
            flex: 0 0 210px;
          }

          &.datePresentation {
            flex: 0 0 170px;
            text-align: center;
          }
        }

        .tableHeadCon {
          cursor: default;
          width: 100%;
          text-align: center;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
        }
      }

      ul.obody {
        min-height: 52px;
        margin: 0 -1px -1px 0;
        transition: all 0.3s linear;

        &:hover {
          background: #f5f7fa;
        }

        li {
          border-right: solid 1px #dfdfdf;
          border-bottom: solid 1px #dfdfdf;
          margin: 0 -1px -1px 0;
        }

        .Packingbox {
          padding: 15px 15px;

          .Packinglist {
            display: flex;
            align-items: center;

            width: 268px;

            p {
              width: 268px;

              display: flex;
              align-items: center;
              margin-bottom: 8px;
              justify-content: space-between;

              span {
                display: flex;

                &:first-child {
                  font-size: 14px;
                  color: #d12a1d;
                  flex: 2;
                  line-height: 20px;

                  &:hover {
                    text-decoration: underline;
                    color: #d12a1d;
                    cursor: pointer;
                  }
                }

                &:last-child {
                  margin-left: 12px;
                  flex: 1;
                  justify-content: center;
                }
              }
            }
          }
        }

        .quxiao {
          width: 78px;
          height: 40px;

          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          line-height: 40px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #2052ce;
        }

        .searchBtn {
          width: 86px;
          min-height: 40px;
          background: #d12a1d;
          border-radius: 8px;

          color: #ffffff;
          font-size: 14px;
        }

        .oNO {
          flex: 0 0 70px;
        }

        .orderNumber {
          flex: 0 0 210px;

          button {
            font-size: 14px;
            color: #d12a1d;
            line-height: 20px;

            &:hover {
              text-decoration: underline;
              color: #d12a1d;
            }
          }
        }

        .datePresentation {
          text-align: center;
          flex: 0 0 170px;
        }

        .upLoad {
          img {
            width: 18px;
            height: 18px;
            cursor: pointer;
          }
        }
      }
    }

    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 30px 0px;

      .el-pagination {
        display: flex;
        align-items: center;
      }

      >a {
        display: inline-block;
        border: 1px solid #dcdfe6;
        height: 28px;
        // background-color: white;
        text-align: center;
        padding: 0 10px;
        font-size: 13px;
        line-height: 28px;
        border-radius: 0;
      }

      /deep/.btn-prev {
        width: 30px;
        height: 30px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #dfdfdf;
        padding: 0;
        margin-right: 15px;
        margin-left: 20px;

        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/.btn-next {
        width: 30px;
        height: 30px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #dfdfdf;
        padding: 0;
        margin-left: 15px;

        .el-icon {
          font-size: 16px;
          color: #000000;
        }
      }

      /deep/ .el-pagination__jump {
        .el-input {
          width: 50px;
          height: 30px;
          background: #ffffff;
          border-radius: 8px;
          margin-left: 5px;

          font-weight: 400;
          font-size: 14px;
          color: #000000;

          .el-input__inner {
            height: 30px;
            border-radius: 8px;
          }
        }
      }

      /* 分页被选中的页码样式 */
      /deep/ .el-pager li {
        margin: 0 5px;
        width: 30px;
        line-height: 30px;
        height: 30px;
        border-radius: 8px;
        // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

        &:hover {
          color: #d12a1d;
        }

        &.active {
          width: 30px;

          height: 30px;
          background: #d12a1d;
          line-height: 30px;
          color: #fff;
          border-radius: 8px;
        }
      }
    }
  }

  .rowAndCenter {
    display: flex;
    align-items: center;
  }

  >nav {
    height: 50px;
    display: flex;

    >span {
      display: flex;
      align-items: center;
      justify-content: center;
      // width: 130px;
      height: 50px;
      padding: 10px;
      background: #e8e8e8;
      border: 1px solid #e1e1e1;
      font-size: 12px;
      text-align: center;

      color: #000000;
      line-height: 16px;

      cursor: pointer;

      &.active {
        background-color: #ffffff;
        border-bottom: none;
      }

      .label {
        display: inline-block;
        margin-right: 7px;
      }

      .numberCount {
        width: 25px;
        height: 25px;
        background: #fbbb21;
        border-radius: 50%;
        font-size: 10px;
        color: #fff;
        text-align: center;
        line-height: 25px;
      }
    }
  }
}
</style>
